import type { ReactNode } from 'react';

export const symbol_mood: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M626-533q22.5 0 38.25-15.5T680-587q0-23-15.75-38.5T626-641q-22.5 0-38.25 15.5T572-587q0 23 15.75 38.5T626-533Zm-292 0q22.5 0 38.25-15.5T388-587q0-23-15.75-38.5T334-641q-22.5 0-38.25 15.5T280-587q0 23 15.75 38.5T334-533Zm-10 421.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM480-480Zm241 241q99-99 99-241t-99-241q-99-99-241-99t-241 99q-99 99-99 241t99 241q99 99 241 99t241-99Zm-241.5-22q57.5 0 106-26t78.5-72.4q6-11.6-.75-22.6-6.75-11-20.25-11H316.92q-13.92 0-20.42 11-6.5 11-.5 22.6 30 46.4 78.5 72.4 48.5 26 105 26Z"
		/>
	</svg>
);
